import React from 'react';
import styled from 'styled-components';
import DeleteIcon from '../../../../Icons/DeleteIcon';
import {defaultTheme} from '@stencil/build-theme';

const ChipUI = ({
  className,
  text,
  actionHandler,
}: {
  className?: string;
  text: string;
  actionHandler: () => void;
}) => (
  <div className={className} onClick={actionHandler}>
    <span>
      <span>{text}</span>
    </span>
    <DeleteIcon width="1rem" height="1rem" color={defaultTheme.colors.goWhite.base} />
  </div>
);

const Chip = styled(ChipUI)(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  padding: ${props.theme.spacing.small} ${props.theme.spacing.base};
  margin: 0 ${props.theme.spacing.small} ${props.theme.spacing.small} 0;
  background-color: ${props.theme.colors.goBrandBlue.base};
  border-radius: ${props.theme.misc.borderRadius.custom(15)};
  > span {
    color: ${props.theme.colors.goWhite.base};
    max-width: 15rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    > span {
      text-transform: capitalize;
      font-size: 1.2rem;
      margin-right: 0.5rem;
    }
  }
  > span {
    font-size: ${props.theme.font.small};
    padding-left: ${props.theme.spacing.small};
  }

`,
);

export default React.memo(Chip);
